<template>
  <div>
    <DialogCustom
      :visible.sync="dialogVisible"
      v-bind="$attrs"
      :title="title"
      :buttons="buttons"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    >
      <slot name="before" />
      <FormCustom
        ref="dialogForm"
        v-model="formModel"
        class="dialog-form-custom"
        :reset.sync="reset"
        :config="formConfig"
        :rules="rules"
        :pureable="pureable"
        :label-position="labelPosition"
        :label-width="labelWidth"
        :show-message="showMessage"
        :validate-on-rule-change="validateOnRuleChange"
        @validate="handleValidate"
      />
     
      <slot name="after" />
    </DialogCustom>
  </div>
</template>

<script>
import DialogCustom from "@/components/DialogCustom";
import FormCustom from "@/components/FormCustom";

export default {
  components: {
    DialogCustom,
    FormCustom,
  },
  inheritAttrs: false,

  model: {
    prop: "formModel",
  },

  props: {
    buttons: {
      type: Object,
      default: () => ({
        cancel: {
          text: "取消",
        },
        confirm: {
          text: "保存",
        },
      }),
    },
    formModel: {
      default: () => ({}),
      type: Object,
    },

    visible: {
      type: Boolean,
      default: false,
    },

    showMessage: {
      type: Boolean,
      default: false,
    },

    formConfig: {
      type: Array,
      default: () => [],
    },

    rules: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    labelPosition: {
      type: String,
      default: "top",
    },

    labelWidth: {
      type: [String, Number],
      default: 80,
    },

    resetAfterClose: {
      type: Boolean,
      default: true,
    },

    // 是否是纯净模式 (删除 renderable === false 的item.prop对应model的值)
    pureable: {
      default: false,
      type: Boolean,
    },

    validateOnRuleChange: {
      default: false,
      type: Boolean,
    },

  },

  data() {
    return {
      reset: false,
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },

  watch: {
    formModel: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
  },

  methods: {
    async handleConfirm() {
      try {
        if (this.rules) {
          await this.$refs.dialogForm.validate();
        }
        const model = JSON.parse(JSON.stringify(this.formModel));
        if (this.$listeners.confirm) {
          await this.$listeners.confirm(model); // $listeners.confirm 须返回Promise
        }

        await this.$nextTick();

        if (this.resetAfterClose) {
          this.reset = true;
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },

    handleValidate(prop, pass, msg) {
      if (!this.timer && !pass) {
        this.timer = setTimeout(() => {
          this.dialogVisible && this.$fail(msg);
          this.timer = null;
        }, 200);
      }
    },

    async handleCancel() {
      try {
        const model = JSON.parse(JSON.stringify(this.formModel));

        this.$listeners.cancel && (await this.$listeners.cancel(model)); // $listeners.confirm 须返回Promise

        if (this.resetAfterClose) {
          console.log(1);
          this.reset = true;
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
</script>
